module.exports = {
    getGuillotineTimeline: function(opts){
        opts = _.extend({
            pixels: 20,
            rotation: -30,
            leftElements: null,
            topElements: null,
            rightElements: null,
            wheels: null,
            duration: 1,
            ease: Linear.easeNone,
        }, opts);

        var timeline = new TimelineMax({
            repeat: -1,
            yoyo: true,
        });

        if (opts.wheels) {
            timeline.to(opts.wheels, opts.duration, {
                rotation: opts.rotation * Math.PI / 90,
                ease: opts.ease
            }, 0);
        }

        if (opts.leftElements) {
            timeline.to(opts.leftElements, opts.duration, {
                y: '+=' + opts.pixels,
                ease: opts.ease
            }, 0);
        }

        if (opts.topElements) {
            timeline.to(opts.topElements, opts.duration, {
                x: '-=' + opts.pixels,
                ease: opts.ease
            }, 0);
        }

        if (opts.rightElements) {
            timeline.to(opts.rightElements, opts.duration, {
                y: '-=' + opts.pixels,
                ease: opts.ease
            }, 0);
        }

        return timeline;
    }
};



// WEBPACK FOOTER //
// ./js/animations/guillotine.js